<template>
    <div class="lw-cols align-items-stretch one-row one-row-tl one-row-tp one-row-sl one-row-sp">

        <div v-if="coursesVisibility" :class="panelStyleClass" class="overview-col col lw-padding-small learnworlds-align-center span_4_of_12 span_4_of_12-tl span_4_of_12-tp span_4_of_12-sl span_4_of_12-sp flex-item flexible">
            <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-very-large no-margin-bottom">
                {{coursesLength}}
            </div>
            <div class="learnworlds-overline-text learnworlds-element">
                {{ $t('bundles.courses') }}
            </div>
        </div>

        <div v-if="initialPriceVisibility" :class="panelStyleClass" class="overview-col col lw-padding-small learnworlds-align-center span_4_of_12 span_4_of_12-tl span_4_of_12-tp span_4_of_12-sl span_4_of_12-sp flex-item flexible ">
            <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-very-large no-margin-bottom">
                {{bundle.currency  || '$'}}{{bundle.price}}
            </div>
            <div class="learnworlds-overline-text learnworlds-element">
                {{ $t('bundles.price') }}
            </div>
        </div>

        <div v-if="finalPriceVisibility" :class="panelStyleClass" class="overview-col col lw-padding-small learnworlds-align-center span_4_of_12 span_4_of_12-tl span_4_of_12-tp span_4_of_12-sl span_4_of_12-sp flex-item flexible ">
            <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-very-large no-margin-bottom">
                {{bundle.currency  || '$'}}{{bundle.discount_price}}
            </div>
            <div class="learnworlds-overline-text learnworlds-element">
                {{ $t('bundles.price_final') }}
            </div>
        </div>

        <div v-if="discountPercentageVisibility" :class="panelStyleClass" class="overview-col col lw-padding-small learnworlds-align-center span_4_of_12 span_4_of_12-tl span_4_of_12-tp span_4_of_12-sl span_4_of_12-sp flex-item flexible">
            <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-very-large no-margin-bottom">
                {{bundle.discount_percentage}}%
            </div>
            <div class="learnworlds-overline-text learnworlds-element">
                {{ $t('bundles.discount') }}
            </div>
        </div>

        <div v-if="savingsVisibility" :class="panelStyleClass" class="overview-col col lw-padding-small learnworlds-align-center span_4_of_12 span_4_of_12-tl span_4_of_12-tp span_4_of_12-sl span_4_of_12-sp flex-item flexible ">
            <div class="learnworlds-main-text learnworlds-element learnworlds-main-text-very-large no-margin-bottom">
                {{bundle.currency  || '$'}}{{bundle.save}}
            </div>
            <div class="learnworlds-overline-text learnworlds-element">
                {{ $t('bundles.save') }}
            </div>
        </div>
    </div>
</template>

<script>
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";
    export default {
        name: "BundleDataLayout1",
        mixins: [
            ComponentTemplatesMixin,
        ],
        props: {
            bundle : {
                type: Object
            },
            coursesVisibility: {
                type: Boolean
            },
            initialPriceVisibility: {
                type: Boolean
            },
            finalPriceVisibility: {
                type: Boolean
            },
            discountPercentageVisibility: {
                type: Boolean
            },
            savingsVisibility: {
                type: Boolean
            },
            panelStyleClass: {
                type: String
            },
        },
        computed: {
            coursesLength () {
                return this.bundle && this.bundle.courses ? this.bundle.courses.length : 0;
            }
        },
        methods: {
            $t (val) {
                return window.LWTranslate.get(val);
            },
        },
    }
</script>
